export default "__VITE_ASSET__D5Zk5ZDd__"